import { Component } from '@angular/core';

@Component({
  selector: 'app-section-titulo-sobre',
  templateUrl: './section-titulo-sobre.component.html',
  styleUrls: ['./section-titulo-sobre.component.scss'],
})
export class SectionTituloSobreComponent {}
